// Aggregation levels supported by the filter pills. Order is significant for
// the admin UI checkbox layout — categories above items mirrors the visual
// hierarchy in the board view.
export const AGGREGATION_LEVEL_VALUES = ['categories', 'items']

export const DEFAULT_AGGREGATION_LEVELS = ['categories', 'items']

// Sentinel format string handled by `resolveMetadataValue` — preserves the
// legacy `formatPlanDate` MM/DD/YY output so existing default rows render
// identically when the new formatter pipeline is in play.
export const PLAN_DATE_FORMAT_KEY = 'planDate'

// Default rows rendered in the item detail panel when `itemMetadata` is
// null/undefined on the config. These mirror the four hardcoded rows that
// existed before SMT-1717.
export const DEFAULT_ITEM_METADATA = [
  { id: 'status', label: 'Status', accessor: 'status', format: null, hideWhenEmpty: false },
  { id: 'advisorNote', label: 'Advisor Notes', accessor: 'metadata.advisorNote', format: null, hideWhenEmpty: false },
  { id: 'nextReviewDate', label: 'Next Review Date', accessor: 'metadata.nextReviewDate', format: PLAN_DATE_FORMAT_KEY, hideWhenEmpty: false },
  { id: 'lastReviewedDate', label: 'Last Reviewed Date', accessor: 'metadata.lastReviewedDate', format: PLAN_DATE_FORMAT_KEY, hideWhenEmpty: false }
]

// Categories had no metadata-row section pre-SMT-1717; preserve that by
// defaulting to an empty list. Admins opt-in by configuring `categoryMetadata`.
export const DEFAULT_CATEGORY_METADATA = []
